import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
} from "@aws-amplify/ui-react";
import { APaddedCenter } from "../components/layout";
import { AH2, AH4 } from "../components/text";
import { useContext } from "react";
import { GlobalContext } from "../context/global";
import { Navigate, useNavigate } from "react-router-dom";
import Logo from "../media/aere_logo_caption_black.png";
import styled from "styled-components";
import { IEventData } from "../interfaces";


const LogoImage = styled(Image)`
  max-width:100%;
  width:300px;
  margin-top:40px;
  margin-bottom:40px;
`


export const ViewEventMenu = () => {
    const navigate = useNavigate();
    const { eventData, setEventData, userData} = useContext(GlobalContext);

    // check we have some user data and redirect them if not.
    // this is in response to an issue where we land back after checkout sometimes.
    if (!userData.haveFetched) {
      return <Navigate to="/user-initial" replace/>
    }

    const setDistanceAndNext = (name: string, distanceMeters : number) => {
      setEventData({
        name,
        distanceMeters: distanceMeters
      })
      next();
    }

    const setVarious = (name?: string, activityType?: IEventData["activityType"], terrain? : IEventData["terrain"], distanceMeters?: number,  ) => {
      setEventData({
        name,
        distanceMeters: distanceMeters || 0,
        terrain: terrain || "Flat" as any,
        activityType: activityType || "Running" as any
      })
      next();
    }



    const next = () => {
      navigate("/event/new")
    }

    return <APaddedCenter>
        <LogoImage src={Logo} alt="aere nutrition logo" />
        <AH2>Let's build your nutrition pack</AH2><br/>
        <AH4>First, select an event or create your own</AH4>
        <br/>
      <Flex direction="Column" justifyContent="center">
        <Button onClick={() => {setDistanceAndNext("My London Marathon", 42200)}}>London Marathon</Button>
        <Button onClick={() => {setDistanceAndNext("My Great North Run", 21100)}}>Great North Run</Button>
        <Button onClick={() => {setVarious("My Trail Run", "Trail Running", "Hilly" )}}>Trail Run</Button> { /* terrain hilly*/}
        <Button onClick={() => {setVarious("My Road Ride", "Cycling")}}>Road Ride</Button>
        <Button onClick={() => {setVarious("My Hike", "Hiking", "Hilly")}}>Hiking</Button> {/* terrain hilly*/}
        <Button variation="primary" onClick={() => { next() }}>Create an Event</Button>
      </Flex>
    </APaddedCenter>
}